
import { defineComponent, ComputedRef, inject, computed } from 'vue'
import { useStore } from '@/store'

export default defineComponent({
  name: 'AgendaTableRoomCell',
  props: {
    roomId: {
      type: String,
      required: true
    }
  },
  setup (props) {
    const { languagePack, getRoomById } = useStore()
    const languageType = inject<ComputedRef<'zh' | 'en'>>('languageType') || { value: 'zh' }
    const roomsStatus = inject<ComputedRef<{ [k: string]: boolean }>>('roomsStatus') || { value: {} }
    const room = computed(() => {
      const room = getRoomById(props.roomId)
      if (room === null) throw new Error('Invalid Room')
      return room
    })
    const roomName = computed(() => room.value[languageType.value].name.split(' / ')[0])
    const isFull = computed(() => !!(roomsStatus.value[props.roomId]))
    const statusText = computed(() => languagePack.value.agenda['room-status'][isFull.value ? 'full' : 'vacancy'])

    return {
      roomName,
      isFull,
      statusText
    }
  }
})
